module.exports = __webpack_public_path__ + "static/media/ex-re.a7517702.jpg";